<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Transactions with directors - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()" [disabled]="disabledirectorgrid">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <form [formGroup]="Transactionswithdirectors" >
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Transactions with directors</h5>-->
              <div class="mb-3">
                <p class="mt-4">Please enter notes on transactions with directors.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
              </div>
            </div>
            <div class="col-12 text-end">
            <button type="button" class="btn themedefault p-1 ps-2 pe-2 mx-1" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" [disabled]="disabledirectorgrid" (click)="openVerticallyCentered(content2)"> + Add New</button>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-md-12">
              <div class="row">
                <div class="table-responsive">
                  <table class="tableheading table dataTable table-bordered border table-striped row-border table-hover pt-10" style="white-space:nowrap !important">
                    <thead>
                      <tr>
                        <th>Name of the director receiving advance or credit</th>
                        <th>Description of the transaction</th>
                        <th>Balance at {{commonService.StartDate}}</th>
                        <th>Advances or credits made</th>
                        <th>Advances or credits repaid</th>
                        <th>Balance at {{commonService.EndDate}}</th>
                        <th class="text-center">Action</th>
                        <!--<th>Delete</th>-->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let data of Gridata;let i=index;">
                        <td>{{data.NameEntityOfficer}}</td>
                        <td>{{data.DescriptionSpecificAdvanceOrCreditItsConditionsDirectors}}</td>
                        <td class="text-end">{{data.AdvancesCreditsDirectors_1}}</td>
                        <td class="text-end">{{data.AdvancesCreditsMadeInPeriodDirectors}}</td>
                        <td class="text-end">{{data.AdvancesCreditsRepaidInPeriodDirectors}}</td>
                        <td class="text-end">{{data.AdvancesCreditsDirectors_2}}</td>

                        <td class="text-center">
                          <button class="btn btn-sm p-1" [disabled]="disabledirectorgrid" (click)="EditgridDetails(content2,i)"><span style="color: #01586c !important;" class="fa fa-edit"></span></button>
                          <button class="btn  btn-sm p-1" [disabled]="disabledirectorgrid" (click)="deletegridDetails(i)"><span class="fa fa-trash-can cantrash text-danger"></span></button>
                        </td>
                        <!--<td align="center" class="">

          </td>-->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row text-center mt-2" *ngIf="!Gridata?.length">
                  <b class="mb-2">No records found</b>
                </div>
                <div class="col-12 mt-3" align="right">
                  <!--<button type="button" class="btn themedefault p-1 ps-2 pe-2 mx-1" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" (click)="openVerticallyCentered(content2)">Add New</button>-->
                </div>
              </div>
            </div>
            <div class="col-xxl-11 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
              <label class="color-black mb-2">
                Please enter any additional information, such as the amount of maximum liability that may be incurred by the
                company in respect of guarantees given on behalf of directors, in the box below.
              </label>
              <textarea class="form-control txt-area allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective formControlName="DirectorsAdvancesCreditGuaranteesFreeøtextComment" maxlength="4000"  rows="5"></textarea>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="Back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 mx-1" (click)="SaveData()" >Next</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<ng-template #content2 let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalCenterTitle"> Transactions with directors </h5>
    <button type="button" class="modal-close" data-bs-dismiss="modal" aria-label="Close" (click)="Close()">
      <i class="icon feather icon-x"></i>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="TransactionswithdirectorsGrid" >
      <div class="row">
        <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-md-12 ps-4">
          <div class="row mb-3">
            <div class="col-12 col-xxl-5 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <label class=" mb-1">
                Name of director receiving advance
                or credit:
              </label>
            </div>
            <div class="col-12 col-xxl-7 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <select class="form-select" formControlName="NameEntityOfficer" [ngClass]="{ 'is-invalid':(!valid && TransactionswithdirectorsGrid.controls['NameEntityOfficer'].value == null)}">
                <option value="null" selected disabled>Select Director</option>
                <option *ngFor="let officer of officerdata" value="{{officer.NameOfDirector}}">{{officer.NameOfDirector}}</option>
              </select>
              <span class="text-danger" *ngIf="(!valid && (TransactionswithdirectorsGrid.controls['NameEntityOfficer'].value == null))">Select a Director</span>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-xxl-5 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <label class=" mb-1">Balance at {{commonService.StartDate}}</label>
            </div>
            <div class="col-12 col-xxl-7 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <div class="input-group">
                <div class="input-group-text ">£</div>
                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="AdvancesCreditsDirectors_1" (change)="calculations()" />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-xxl-5 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <label class=" mb-1">Advances or credits made:</label>
            </div>
            <div class="col-12 col-xxl-7 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <div class="input-group">
                <div class="input-group-text ">£</div>
                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="AdvancesCreditsMadeInPeriodDirectors" (change)="calculations()"/>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-xxl-5 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <label class=" mb-1">Advances or credits repaid:</label>
            </div>
            <div class="col-12 col-xxl-7 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <div class="input-group">
                <div class="input-group-text ">£</div>
                <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="AdvancesCreditsRepaidInPeriodDirectors" (change)="calculations()"/>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-xxl-5 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <label class=" mb-1">Balance at {{commonService.EndDate}}</label>
            </div>
            <div class="col-12 col-xxl-7 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <div class="input-group">
                <div class="input-group-text ">£</div>
                <input type="text" class="form-control text-end "  formControlName="AdvancesCreditsDirectors_2" readonly/>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-xxl-5 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <label class=" mb-1">Description of the transaction:</label>
            </div>
            <div class="col-12 col-xxl-7 col-xl-12 col-lg-12 col0md-12 col-sm-12">
              <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective cols="4" formControlName="DescriptionSpecificAdvanceOrCreditItsConditionsDirectors" maxlength="500" ></textarea>
            </div>
          </div>
        </div>
        <div class="col-12" align="right">
          <button type="button" class="btn themedefault ps-2 pe-2 p-1 mx-2" (click)="Submit()">OK</button>
          <button type="button" class="btn ps-2 pe-2 p-1 me-0" style="color: #014047; background-color: #73889329; border-color: #74889254;" (click)="Close()" >Cancel</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>
